import { useNavigate, useLocation } from 'react-router-dom';

// This is just so we can navigate back properly
// It's possible we could do that with react itself , if we convert yet again to their latest shenanigans - https://reactrouter.com/6.30.0/routers/create-browser-router
// But honestly, fuck that.

const useGncHistory = (props) => {
    const navigate = useNavigate()
    const location = useLocation()
    const pathname = location.pathname

    const getHistory = () => {
        let h = []
        try { h = JSON.parse(sessionStorage.getItem("history")) } catch(e) { h = [] }
        if( ! h ) { return [] }
        return h
    }

    const setHistory = (h) => {
        sessionStorage.setItem("history", JSON.stringify(h))
    }
    
    const addToHistory = (path) => {
        let history = getHistory()
        history.unshift(path)
        
        // I think a history of 10 items is enough...
        if( history.length > 10 ) {
            history = history.splice(0, 10)
        }
        //console.log("useGncHistory: added", history)
        setHistory(history)
    }

    const replaceCurrentPath = (path) => {
        //console.log("useGncHistory: replace Current path with", path)
        let history = getHistory()
        if( ! path ) {
            return
        }
        history.shift()
        history.unshift(path)
        setHistory(history)
    }
    
    const goBack = () => {
        let history = getHistory()
        let current = history.shift()
        let goBack = history.shift()
        
        while( goBack === pathname && history.length > 0 ) {
            goBack = history.shift()
        }
        if( goBack === pathname ) {
            goBack = null
        }
        const defaultRedirectUrl = pathname.substring(0, pathname.lastIndexOf('/'))
        
        //console.log("useGncHistory: goBack", goBack, history)
        setHistory(history)
        navigate(goBack || defaultRedirectUrl)
    }

    return {
        getHistory,
        addToHistory,
        replaceCurrentPath,
        goBack,
    }
}
export default useGncHistory
